import React from 'react';
import FilterBar from '../../components/filters/FilterBar';
import { SharedWalletMetrics } from '../../components/dashboard/metrics';
import WalletMetrics from '../../components/dashboard/metrics/WalletMetrics';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import { useFilterPersistence } from '../../hooks/useFilterPersistence';
import { useSettings } from '../../contexts/SettingsContext';
import { PAGE_INFO, FILTER_PERIODS } from '../../constants';
import './Wallets.css';

/**
 * Wallets Page Component
 * Wallet analytics and shared wallets
 */
const Wallets = () => {
  const { period, setPeriod, platform, setPlatform } = useFilterPersistence({
    pageKey: 'wallets',
    defaultPeriod: FILTER_PERIODS.ALL,
    defaultPlatform: null
  });
  const settings = useSettings();
  const compact = settings.compactMode;

  const filters = (
    <FilterBar
      period={period}
      onPeriodChange={setPeriod}
      platform={platform}
      onPlatformChange={setPlatform}
    />
  );

  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.WALLETS.title}
        description={PAGE_INFO.WALLETS.description}
        filters={filters}
      >
        <div className="wallets-content">
          <div className="wallets-grid">
            <WalletMetrics period={period} platform={platform} compact={compact} />
            <SharedWalletMetrics period={period} compact={compact} />
          </div>
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default Wallets;

